<template>
  <Row class-name="c-adcount">
    <Col span="24">
      <div v-for="(cond, idx) in conditions" :key="idx" class="c-condition-type">
        <input-number-plus
          :max="10"
          :min="0.1"
          :step="0.1"
          :precision="2"
          :value="cond"
          placeholder="请输入预警消耗值，范围：0-999999999.99 保留两位小数"
          :width="352"
          @change="changeCond(idx, ...arguments)"
        />
        <Icon v-if="trash" type="ios-trash" size="25" color="#ff635c" style="margin-left: 8px; cursor: pointer" @click.stop="del(idx)" />
      </div>
    </Col>
    <Col span="24" v-if="addicon">
      <Button icon="md-add" class="c-add-btn" @click="append">预警消耗值</Button>
    </Col>
  </Row>
</template>
<script>
import InputNumberPlus from '@/components/input/input-number-plus'
export default {
  name: 'AdcountCond',
  components: { InputNumberPlus },
  props: {
    value: {
      type: Array
    },
    maxLen: {
      type: Number
    }
  },
  computed: {
    trash() {
      return this.conditions.length > 1
    },
    addicon() {
      return this.conditions.length < this.maxLen
    }
  },
  data() {
    return {
      conditions: []
    }
  },
  methods: {
    append() {
      this.conditions.push('')
    },
    updateCondition() {
      this.conditions = []
      this.value.forEach((ret) => {
        this.conditions.push(ret)
      })
    },
    changeCond() {
      const index = arguments[0]
      const val = arguments[1]
      this.conditions[index] = val
    },
    del(index) {
      this.conditions.splice(index, 1)
    }
  },
  watch: {
    conditions: {
      handler(val) {
        this.$emit('input', val)
      },
      deep: true
    }
  },
  mounted() {
    this.updateCondition()
  }
}
</script>
<style lang="scss" scoped>
.c-adcount {
  min-width: 774px;

  .c-condition-type {
    margin-bottom: 20px;
  }

  .c-add-btn {
    margin-left: 0;
  }
}
</style>
